import { OptionType } from 'components/form-fields/FormAutoComplete';

export enum AssigneeFormFieldsNames {
  User = 'user',
}

export interface AssigneeFormFields {
  [AssigneeFormFieldsNames.User]?: OptionType | null;
}
